import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const AdDetail = lazy(() => import('./AdDetail'))
const SbDetail = lazy(() => import('./SbDetail'))

//	///////////////////////
//	MARK: EXPORTS
// A12 — les registres sont à la flotte ; le client lit le statut AD et SB de ses avions depuis leur fiche.
export const MaintenanceDirectiveRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--maintenance--fleet']}>
    <Route path='ad/file/:directiveId/*' element={<AdDetail />} />
    <Route path='sb/file/:bulletinId/*' element={<SbDetail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
